import { MessageCircle } from "lucide-react";

const WA_NUMBER = "917664861586";
const WA_MSG = encodeURIComponent("Hello, I need more information about IIBF BCBF registration.");

export default function WhatsAppButton({ variant = "floating" }) {
  const href = `https://wa.me/${WA_NUMBER}?text=${WA_MSG}`;
  if (variant === "floating") {
    return (
      <a
        data-testid="whatsapp-floating-btn"
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 z-50 flex items-center gap-2 rounded-full bg-[#10B981] hover:bg-[#059669] text-white px-5 py-3 shadow-lg shadow-emerald-600/25 transition-colors duration-200 no-print"
      >
        <MessageCircle size={18} strokeWidth={2.5} />
        <span className="text-sm font-semibold hidden sm:inline">Chat on WhatsApp</span>
      </a>
    );
  }
  return (
    <a
      data-testid="whatsapp-contact-btn"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="inline-flex items-center gap-2 rounded-md bg-[#10B981] hover:bg-[#059669] text-white px-6 py-3 font-semibold text-sm transition-colors duration-200"
    >
      <MessageCircle size={18} strokeWidth={2.5} />
      Contact on WhatsApp
    </a>
  );
}

export function WhatsAppInfo() {
  return (
    <div data-testid="whatsapp-info-section" className="rounded-lg border border-emerald-200 bg-emerald-50 p-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
      <div>
        <p className="tech-label text-emerald-700">More Information</p>
        <p className="mt-1 text-base font-semibold text-zinc-900">For BCBF registration queries, reach us on WhatsApp</p>
        <p className="text-sm text-zinc-600 mt-0.5">+91 7664861586</p>
      </div>
      <WhatsAppButton variant="inline" />
    </div>
  );
}
